// Guide/blog articles for SEO. Rendered at /guider and /guider/:slug.

export const posts = [
  {
    slug: "sa-ofta-bor-du-tvatta-taket",
    title: "Så ofta bör du tvätta taket – komplett guide",
    metaTitle: "Så ofta bör du tvätta taket? Komplett guide 2026 | HPR",
    metaDescription:
      "Hur ofta ska man tvätta taket? Vi går igenom intervall för olika taktyper, tecken på att det är dags och varför skonsam taktvätt lönar sig.",
    excerpt:
      "Hur ofta behöver taket egentligen tvättas? Här är tumreglerna för olika taktyper – och tecknen på att det är dags.",
    date: "2026-05-12",
    readMins: 5,
    heroImage: "/taktvatt.webp",
    sections: [
      {
        h2: "Hur ofta ska man tvätta taket?",
        body: [
          "Som tumregel bör ett tak i Stockholms- och Uppsalaområdet tvättas vart 3–5:e år. Hur ofta beror på takets läge, material och hur mycket skugga och träd som finns runt huset. Ett skuggigt, norrvänt tak nära skog behöver tvättas oftare än ett soligt, öppet tak.",
        ],
      },
      {
        h2: "Riktlinjer för olika taktyper",
        body: ["Olika takmaterial samlar påväxt olika snabbt:"],
        list: [
          "Betongpannor: vart 3–4:e år – gropig yta som mossa trivs på.",
          "Tegelpannor: vart 4–5:e år.",
          "Plåt- och papptak: vid behov, oftast vart 4–6:e år.",
          "Eternit/äldre tak: kontakta alltid proffs – hanteras varsamt.",
        ],
      },
      {
        h2: "5 tecken på att det är dags",
        body: ["Vänta inte tills taket är helt övervuxet. Hör av dig när du ser något av följande:"],
        list: [
          "Gröna eller svarta fläckar av mossa och alger.",
          "Mossa som växer i skarvarna mellan pannorna.",
          "Grus och växtrester i hängrännorna.",
          "Missfärgningar och \"ränder\" nedför taket.",
          "Pannor som börjar spricka eller lossna.",
        ],
      },
      {
        h2: "Varför skonsam mjuktvätt lönar sig",
        body: [
          "Aggressiv högtryckstvätt kan verka effektivt men river på ytskiktet och kortar takets livslängd. Vi rekommenderar i stället skonsam mjuktvätt (lågtryck) med biologiskt nedbrytbara medel som löser upp mossa och alger utan att skada pannorna.",
          "Ett rent tak håller tätt längre, ser snyggare ut och behåller husets värde. Regelbunden taktvätt är billig försäkring jämfört med ett för tidigt takbyte.",
        ],
      },
    ],
  },
  {
    slug: "taktvatt-eller-takmalning",
    title: "Taktvätt eller takmålning – vad behöver ditt tak?",
    metaTitle: "Taktvätt eller takmålning – vad behöver ditt tak? | HPR",
    metaDescription:
      "Ska du bara tvätta taket eller även måla om det? Vi förklarar skillnaden, när respektive lönar sig och vad du kan förvänta dig av resultatet.",
    excerpt:
      "Räcker det med en taktvätt, eller bör taket målas om? Så avgör du vad ditt tak faktiskt behöver.",
    date: "2026-05-20",
    readMins: 4,
    heroImage: "/takmalning.webp",
    sections: [
      {
        h2: "Kort om skillnaden",
        body: [
          "Taktvätt tar bort mossa, alger och lav och återställer takets utseende. Takmålning gör samma sak – men avslutas med ett nytt färgskikt som förseglar och skyddar pannorna, vilket förlänger livslängden ytterligare.",
        ],
      },
      {
        h2: "När räcker det med taktvätt?",
        body: [
          "Om pannorna är hela och i grunden bra skick, men taket är missfärgat av mossa och alger, räcker oftast en taktvätt. Det är den snabbaste och billigaste åtgärden för att fräscha upp taket.",
        ],
      },
      {
        h2: "När bör du måla om taket?",
        body: [
          "Har pannorna börjat bli poröst grå, kritar av sig eller tappat sin yta, ger en takmålning både ett nytt utseende och ett skyddande ytskikt. Vår process är: mjuktvätt, grundning och två strykningar väderbeständig färg. Resultatet håller normalt 10–15 år.",
        ],
      },
      {
        h2: "Vårt råd",
        body: [
          "Boka en kostnadsfri besiktning så bedömer vi takets skick på plats och ger en rekommendation – utan att du binder dig. Ofta är kombinationen taktvätt + takmålning den mest lönsamma lösningen på sikt.",
        ],
      },
    ],
  },
  {
    slug: "rot-avdrag-taktvatt-takmalning",
    title: "ROT-avdrag för taktvätt och takmålning – så funkar det",
    metaTitle: "ROT-avdrag taktvätt & takmålning – så funkar det 2026 | HPR",
    metaDescription:
      "Kan du få ROT-avdrag för taktvätt och takmålning? Vi förklarar reglerna, hur mycket du kan dra av och hur HPR sköter administrationen åt dig.",
    excerpt:
      "Visste du att arbetskostnaden för taktvätt och takmålning ofta är ROT-berättigad? Så mycket kan du spara.",
    date: "2026-05-28",
    readMins: 4,
    heroImage: "/hero-aerial.webp",
    sections: [
      {
        h2: "Vad är ROT-avdrag?",
        body: [
          "ROT-avdraget är en skattereduktion för arbetskostnaden vid renovering och underhåll av din bostad. Taktvätt och takmålning räknas som sådant underhåll och är därför oftast ROT-berättigat för privatpersoner.",
        ],
      },
      {
        h2: "Hur mycket kan du dra av?",
        body: [
          "ROT-avdraget uppgår till 30% av arbetskostnaden, upp till ett tak per person och år. Eftersom en stor del av kostnaden för taktvätt och takmålning är just arbete blir besparingen ofta betydande.",
          "Observera att avdraget gäller arbetskostnaden – inte material eller resor. Vi specificerar alltid detta tydligt i din offert.",
        ],
      },
      {
        h2: "Så sköter HPR det åt dig",
        body: [
          "Du behöver inte göra något krångligt. Vi drar av ROT-beloppet direkt på din faktura och sköter all administration mot Skatteverket. Du betalar helt enkelt bara nettobeloppet.",
        ],
      },
      {
        h2: "Villkor att känna till",
        body: ["Ett par saker är bra att veta:"],
        list: [
          "Du måste äga bostaden och ha tillräckligt med ROT-utrymme kvar för året.",
          "Avdraget gäller villa, radhus och bostadsrätt (inte nybyggnation).",
          "Vi hjälper dig gärna att reda ut om just ditt jobb är berättigat.",
        ],
      },
    ],
  },
  {
    slug: "mossa-pa-taket",
    title: "Mossa och alger på taket – därför bör du ta bort det",
    metaTitle: "Mossa på taket? Därför bör du ta bort det direkt | HPR",
    metaDescription:
      "Mossa och alger på taket är inte bara fult – det kan skada taket och leda till fuktproblem. Så påverkar påväxten taket och så tar du bort den skonsamt.",
    excerpt:
      "Mossa på taket är mer än en skönhetsfråga – det kan förkorta takets livslängd. Här är varför du bör agera.",
    date: "2026-06-02",
    readMins: 4,
    heroImage: "/taktvatt-split.jpg",
    sections: [
      {
        h2: "Varför växer det mossa på taket?",
        body: [
          "Mossa, alger och lav trivs i fuktiga, skuggiga miljöer – något som är vanligt i Stockholms- och Uppsalaområdets villaträdgårdar med träd och norrvända taksidor. Sporer sprids med vinden och får snabbt fäste i takets ojämnheter.",
        ],
      },
      {
        h2: "Så skadar påväxten taket",
        body: ["Obehandlad mossa är inte bara fult – den kan orsaka konkreta skador:"],
        list: [
          "Mossan håller kvar fukt mot pannorna, vilket ökar risken för frostsprängning vintertid.",
          "Rötter tränger in i skarvar och kan lyfta och spräcka pannorna.",
          "Löst material täpper igen hängrännor och avlopp.",
          "Fukt som blir kvar kan på sikt leda till läckage och rötskador.",
        ],
      },
      {
        h2: "Ta bort mossan – skonsamt",
        body: [
          "Undvik kraftig högtryckstvätt som river på ytan. Vi använder skonsam mjuktvätt med biologiskt nedbrytbara medel som löser upp påväxten och samtidigt motverkar att den kommer tillbaka lika snabbt.",
          "Ju tidigare du agerar, desto billigare blir det. Boka en kostnadsfri besiktning så bedömer vi takets skick och ger ett fast pris.",
        ],
      },
    ],
  },
  {
    slug: "vad-kostar-takmalning",
    title: "Vad kostar takmålning? Prisguide 2026",
    metaTitle: "Vad kostar takmålning? Prisguide 2026 | HPR",
    metaDescription:
      "Vad kostar det att måla taket? Vi går igenom priser per kvadratmeter, vad som påverkar kostnaden och hur mycket du sparar med ROT-avdrag.",
    excerpt:
      "Vad kostar det egentligen att måla taket? Här är prisintervallen, vad som påverkar och hur ROT sänker priset.",
    date: "2026-06-08",
    readMins: 5,
    heroImage: "/takmalning.webp",
    sections: [
      {
        h2: "Ungefärligt pris för takmålning",
        body: [
          "Takmålning inklusive tvätt kostar normalt mellan 26 600 och 79 800 kr för en villa, beroende på takets storlek och skick. Räknat per kvadratmeter landar det oftast på 250–450 kr/m², där rengöring, grundning och två strykningar färg ingår.",
        ],
      },
      {
        h2: "Det här påverkar priset",
        body: ["Flera faktorer avgör slutpriset:"],
        list: [
          "Takets storlek (m²) och lutning.",
          "Takmaterial – tegel, betong eller plåt.",
          "Skick: hur mycket mossa, alger och lagningar som krävs.",
          "Tillgänglighet och behov av ställning eller lift.",
          "Antal takkupor, skorstenar och detaljer.",
        ],
      },
      {
        h2: "Så sänker ROT-avdraget priset",
        body: [
          "Eftersom en stor del av kostnaden är arbete får du som privatperson dra av 30% av arbetskostnaden via ROT-avdraget. Vi drar av det direkt på fakturan – du betalar bara nettobeloppet.",
        ],
      },
      {
        h2: "Lönar sig takmålning?",
        body: [
          "Ja – en takmålning kostar en bråkdel av ett takbyte (som ofta går på 150 000 kr och uppåt) och kan förlänga takets livslängd med 10–15 år. Det är en av de mest lönsamma underhållsåtgärderna för villan.",
          "Vill du veta exakt vad ditt tak kostar? Boka en kostnadsfri besiktning så får du ett fast pris utan förpliktelser.",
        ],
      },
    ],
  },
  {
    slug: "basta-tiden-for-taktvatt",
    title: "Bäst tid på året för taktvätt och takmålning",
    metaTitle: "Bäst tid på året för taktvätt & takmålning | HPR",
    metaDescription:
      "När är det bäst att tvätta och måla taket? Vi går igenom vår och höst, temperaturer och varför du bör boka i god tid inför säsongen.",
    excerpt:
      "Vår, sommar eller höst – när är det egentligen bäst att tvätta och måla taket? Så tänker proffsen.",
    date: "2026-06-12",
    readMins: 4,
    heroImage: "/hero-aerial.webp",
    sections: [
      {
        h2: "Taktvätt går att göra större delen av året",
        body: [
          "Taktvätt kan utföras från tidig vår till sen höst, så länge det inte är frost. Många väljer våren – då syns vinterns påväxt tydligt – eller hösten, för att rensa bort mossa inför vintern.",
        ],
      },
      {
        h2: "Takmålning kräver rätt temperatur",
        body: [
          "Takmålning är mer väderkänsligt. Färgen behöver torka i rätt förhållanden, vanligtvis vid temperaturer över 5–10°C och torrt väder. Därför är sen vår, sommar och tidig höst den bästa perioden för målning.",
        ],
      },
      {
        h2: "Boka i god tid",
        body: [
          "Efterfrågan är som störst under vår och sommar. Vill du ha jobbet gjort under högsäsong lönar det sig att boka besiktning i god tid – gärna redan under vintern eller tidig vår.",
        ],
        list: [
          "Vinter/tidig vår: perfekt för att boka och planera.",
          "Vår–höst: utförande av taktvätt.",
          "Sen vår–tidig höst: bästa perioden för takmålning.",
        ],
      },
      {
        h2: "Vårt tips",
        body: [
          "Boka en kostnadsfri besiktning nu så planerar vi in jobbet vid rätt tidpunkt för just ditt tak – du slipper köa när alla andra ringer samtidigt.",
        ],
      },
    ],
  },
  {
    slug: "sa-kanner-du-igen-ett-taklackage",
    title: "Så känner du igen ett takläckage – 7 varningstecken",
    metaTitle: "Så känner du igen ett takläckage – 7 tecken | HPR",
    metaDescription:
      "Misstänker du läckage i taket? Här är de vanligaste varningstecknen, var du ska leta och vad du bör göra innan skadan blir dyr.",
    excerpt:
      "Ett takläckage upptäcks ofta för sent. Lär dig känna igen varningstecknen innan det leder till dyra fuktskador.",
    date: "2026-06-16",
    readMins: 5,
    heroImage: "/nocktatning.webp",
    sections: [
      {
        h2: "Varför är läckage så lömska?",
        body: [
          "Ett takläckage syns sällan direkt där vattnet kommer in – det rinner ofta en bit innan det visar sig inne i huset. Därför upptäcks skadan ofta först när fukten redan spridit sig. Ju tidigare du agerar, desto billigare blir det.",
        ],
      },
      {
        h2: "7 vanliga varningstecken",
        body: ["Håll utkik efter dessa tecken:"],
        list: [
          "Bruna eller gulaktiga fläckar i taket eller på väggar inomhus.",
          "Fukt- eller mögellukt på vinden.",
          "Färg eller tapet som bubblar eller flagnar.",
          "Fuktfläckar eller droppar på vindsbjälkar efter regn.",
          "Trasiga, spruckna eller förskjutna takpannor.",
          "Rost eller skador kring skorsten, ventiler och genomföringar.",
          "Mossa och skräp som dämmer upp vatten i skarvar och rännor.",
        ],
      },
      {
        h2: "Var läckage oftast uppstår",
        body: [
          "De känsligaste punkterna är genomföringar (skorsten, ventilation), takfönster, vinklar och nock. Just nocken är en vanlig läckagepunkt – en professionell nocktätning håller den tät och skyddar mot inträngande vatten och skadedjur.",
        ],
      },
      {
        h2: "Vad du bör göra",
        body: [
          "Vänta inte. Boka en kostnadsfri besiktning så inspekterar vi taket, lokaliserar problemet och föreslår rätt åtgärd – från tätning av enskilda punkter till taktvätt och målning. Att åtgärda tidigt är alltid billigare än att renovera efter en fuktskada.",
        ],
      },
    ],
  },
  {
    slug: "vad-kostar-taktvatt-stockholm",
    title: "Vad kostar taktvätt i Stockholm? Prisguide",
    metaTitle: "Vad kostar taktvätt i Stockholm? Prisguide | HPR",
    metaDescription: "Vad kostar professionell taktvätt i Stockholm? Se vilka faktorer som påverkar priset, när ROT kan vara aktuellt och hur du får en tydlig offert.",
    excerpt: "Storlek, taktyp och mängden påväxt påverkar priset. Här är vad som ingår i en genomtänkt offert för taktvätt.",
    date: "2026-10-02",
    readMins: 5,
    heroImage: "/taktvatt.webp",
    sections: [
      { h2: "Vad påverkar priset på taktvätt?", body: ["En taktvätt prissätts efter förutsättningarna på plats. Takets area, lutning, material, mängden mossa samt åtkomst spelar alla in. Därför är ett riktat pris utan att ha sett taket sällan rättvisande."] },
      { h2: "Det här bör en offert beskriva", body: ["Be om ett underlag där arbetsomfattning och villkor framgår tydligt. Då blir det lättare att jämföra olika erbjudanden."], list: ["Vilka ytor som ska rengöras och behandlas.", "Hur taktyp, lutning och tillgång påverkar arbetet.", "Om skydd av omgivande ytor, städning och dokumentation ingår.", "Hur ROT-avdrag hanteras när arbetet är berättigat."] },
      { h2: "Så får du ett exakt pris", body: ["HPR börjar med en kostnadsfri TakKoll i Stockholm och Uppsala. Vi går igenom takets synliga skick och lämnar sedan ett tydligt prisförslag innan arbetet planeras. Det ger bättre beslutsunderlag än en generell kvadratmeteruppgift."] },
    ],
  },
  {
    slug: "ar-takmalning-vart-pengarna",
    title: "Är takmålning värt pengarna?",
    metaTitle: "Är takmålning värt pengarna? Så avgör du | HPR",
    metaDescription: "Är takmålning en bra investering? Lär dig när målning kan vara lämplig, när annan åtgärd behövs och vad en TakKoll bör bedöma.",
    excerpt: "Takmålning kan vara rätt för ett lämpligt betongtak — men inte för varje tak. Här är frågorna du ska ställa först.",
    date: "2026-10-02",
    readMins: 5,
    heroImage: "/takmalning.webp",
    sections: [
      { h2: "När kan takmålning vara ett bra val?", body: ["Takmålning kan vara en relevant underhållsåtgärd när takets grundkonstruktion och pannor är i lämpligt skick men ytan behöver förnyas. En noggrann rengöring och rätt förbehandling är avgörande för resultatet."] },
      { h2: "När bör du välja en annan åtgärd?", body: ["Målning är inte en lösning på trasiga pannor, läckage eller underliggande konstruktionsproblem. Om taket har omfattande skador behöver dessa bedömas och åtgärdas först."], list: ["Synliga sprickor eller många skadade pannor.", "Fukttecken på vinden eller kring genomföringar.", "Ett ytskikt som inte är lämpligt för målning.", "Osäkerhet kring takets ålder eller tidigare åtgärder."] },
      { h2: "Börja med en saklig bedömning", body: ["En TakKoll ger möjlighet att bedöma förutsättningarna innan du väljer taktvätt, målning eller annan åtgärd. HPR lämnar en tydlig rekommendation utifrån takets synliga skick — och berättar om målning inte är rätt väg."] },
    ],
  },
  {
    slug: "hur-lange-haller-takmalning",
    title: "Hur länge håller takmålning?",
    metaTitle: "Hur länge håller takmålning? Faktorer som avgör | HPR",
    metaDescription: "Hur länge håller en professionell takmålning? Läs om förbehandling, takmaterial, väderläge och underhåll som påverkar resultatets hållbarhet.",
    excerpt: "Hållbarheten beror mindre på färgburken och mer på förarbetet, takets skick och hur väl åtgärden passar materialet.",
    date: "2026-10-02",
    readMins: 4,
    heroImage: "/takmalning.webp",
    sections: [
      { h2: "Förarbetet styr resultatet", body: ["En takmålning håller bäst när underlaget är rent, torrt och lämpligt för färgsystemet. Därför behöver taket bedömas, rengöras och förbehandlas innan målningen utförs."] },
      { h2: "Faktorer som påverkar hållbarheten", body: ["Samma färg kan prestera olika beroende på förutsättningarna. Takets material, väderstreck, närhet till träd, tidigare behandlingar och hur vatten leds bort från taket spelar roll."], list: ["Pannornas och ytskiktets befintliga skick.", "Rengöring och grundning före målning.", "Fukt, skugga och påväxt i takets omgivning.", "Löpande kontroll av nock, genomföringar och hängrännor."] },
      { h2: "Planera för fortsatt takvård", body: ["Målning är inte ett skäl att sluta kontrollera taket. Regelbunden översyn hjälper dig att upptäcka ny påväxt och mindre skador i tid. Vid TakKoll går HPR igenom vad som är rimligt för ditt specifika tak."] },
    ],
  },
  {
    slug: "taktvatt-eller-takbyte",
    title: "Taktvätt eller takbyte – vad ska man välja?",
    metaTitle: "Taktvätt eller takbyte – vad ska man välja? | HPR",
    metaDescription: "Räcker det med taktvätt eller är takbyte nödvändigt? Lär dig skillnaden mellan ytpåväxt, underhållsbehov och tecken som kräver vidare bedömning.",
    excerpt: "Mossa betyder inte automatiskt att taket måste bytas. Så skiljer du ett underhållsbehov från tecken på större åtgärd.",
    date: "2026-10-02",
    readMins: 5,
    heroImage: "/taktvatt-split.jpg",
    sections: [
      { h2: "När kan taktvätt räcka?", body: ["Om takets pannor och underliggande konstruktion är i gott skick men ytan har mossa, alger eller smuts kan skonsam taktvätt vara en relevant åtgärd. Syftet är att ta hand om påväxt utan att utsätta materialet för onödigt slitage."] },
      { h2: "Tecken på att du behöver mer än rengöring", body: ["Vissa signaler bör bedömas innan du planerar en tvätt. De kan tyda på att reparation eller en mer omfattande utredning behövs."], list: ["Återkommande fuktfläckar eller läckage inomhus.", "Många spruckna, glidna eller saknade pannor.", "Synliga skador vid nock, plåtdetaljer eller genomföringar.", "Rötskador eller fukttecken på vinden."] },
      { h2: "Gör inte valet i blindo", body: ["En visuell TakKoll kan hjälpa till att tydliggöra nästa steg, men ersätter inte en byggnadsteknisk besiktning. HPR rekommenderar alltid den åtgärd som är rimlig utifrån det synliga skicket och hänvisar vidare när ett större problem behöver utredas."] },
    ],
  },
  {
    slug: "sa-fungerar-professionell-takbehandling",
    title: "Hur fungerar professionell takbehandling?",
    metaTitle: "Professionell takbehandling – så fungerar den | HPR",
    metaDescription: "Så fungerar professionell takbehandling för att förebygga påväxt. Läs om bedömning, anpassad metod och varför taktyp och skick alltid avgör.",
    excerpt: "En takbehandling börjar med rätt bedömning — inte med samma metod för varje tak.",
    date: "2026-10-02",
    readMins: 4,
    heroImage: "/hero-aerial.webp",
    sections: [
      { h2: "Bedömning före behandling", body: ["Professionell takbehandling utgår från takets material, synliga skick och mängden påväxt. Behandlingen behöver vara lämplig för ytan och komma efter eventuell rengöring eller annan nödvändig åtgärd."] },
      { h2: "En anpassad arbetsgång", body: ["Efter TakKoll planeras arbetet utifrån takets förutsättningar. Målet är att motverka ny påväxt och hjälpa till att hålla ytan i bättre skick över tid."], list: ["Visuell genomgång av takets tillgängliga ytor.", "Bedömning av påväxt, skador och lämplig metod.", "Tydlig offert innan arbete påbörjas.", "Dokumentation av överenskommen åtgärd."] },
      { h2: "När ska du boka en TakKoll?", body: ["Boka när du ser återkommande mossa, gröna beläggningar eller missfärgning — särskilt på skuggiga eller norrvända takytor. Att bedöma taket i tid gör det enklare att välja en genomtänkt underhållsåtgärd."] },
    ],
  },
  {
    slug: "takunderhall-for-brf",
    title: "Så fungerar takunderhåll för bostadsrättsföreningar",
    metaTitle: "Takunderhåll för BRF – planering och underlag | HPR",
    metaDescription: "Så planerar en BRF takunderhåll. Läs om statusbedömning, offertunderlag, dokumentation och hur styrelsen kan förenkla nästa beslut.",
    excerpt: "Med rätt underlag blir det enklare för styrelsen att planera taktvätt, målning och andra takåtgärder.",
    date: "2026-10-02",
    readMins: 5,
    heroImage: "/hero-aerial.webp",
    sections: [
      { h2: "Börja med fastighetens förutsättningar", body: ["För en BRF handlar takunderhåll om mer än en enskild åtgärd. Taktyp, tillgänglighet, tidigare arbeten och tidplan behöver vägas in för att styrelsen ska kunna fatta ett genomtänkt beslut."] },
      { h2: "Vad bör styrelsen ha i sitt underlag?", body: ["Ett tydligt underlag förenklar både beslut, upphandling och kommunikation med de boende."], list: ["Vilka takytor och moment offerten omfattar.", "Bild- eller statusunderlag från genomgången.", "Tidsplan och praktiska förutsättningar inför arbetet.", "Pris, villkor och relevant dokumentation efter avslut."] },
      { h2: "Planerat underhåll ger bättre kontroll", body: ["Genom att kontrollera taket regelbundet kan föreningen prioritera åtgärder i rimlig ordning. HPR erbjuder ett kostnadsfritt första möte för att diskutera fastighetens behov och vilken typ av underlag som passar styrelsen."] },
    ],
  },
  {
    slug: "rengora-solpaneler-pa-ratt-satt",
    title: "Hur rengör man solpaneler på rätt sätt?",
    metaTitle: "Rengöra solpaneler rätt – skonsam solcellstvätt | HPR",
    metaDescription: "Så rengör du solpaneler på rätt sätt. Läs om säkerhet, skonsam rengöring, när professionell solcellstvätt kan vara lämplig och vad du bör undvika.",
    excerpt: "Smuts, pollen och fågelspillning kan påverka panelernas yta. Så tänker du säkert och skonsamt kring rengöring.",
    date: "2026-10-02",
    readMins: 4,
    heroImage: "/solceller.png",
    sections: [
      { h2: "Säkerheten kommer först", body: ["Solpaneler sitter ofta högt och på lutande tak. Undvik att gå på paneler eller utföra rengöring där fallrisk finns. Följ alltid paneltillverkarens skötselanvisningar och ta hjälp när arbetet kräver säkra arbetsmetoder."] },
      { h2: "Rengör skonsamt", body: ["Rätt metod ska vara skonsam mot panelernas yta och anpassad efter förutsättningarna. Hårda redskap, starka kemikalier och felaktig vattenanvändning kan göra mer skada än nytta."], list: ["Kontrollera tillverkarens rekommendationer först.", "Undvik slipande redskap och starka rengöringsmedel.", "Planera arbetet när panelerna inte är mycket varma.", "Låt en fackman hantera svåråtkomliga eller större anläggningar."] },
      { h2: "När är professionell solcellstvätt lämplig?", body: ["För villaägare, BRF:er och fastighetsägare med svåråtkomliga paneler kan en skonsam professionell rengöring vara ett tryggt alternativ. HPR bedömer förutsättningarna och använder anpassad rengöring för panelernas ytor."] },
    ],
  },
  {
    slug: "valja-foretag-for-taktvatt-stockholm",
    title: "Så väljer du företag för taktvätt i Stockholm",
    metaTitle: "Välja företag för taktvätt i Stockholm – checklista | HPR",
    metaDescription: "En saklig checklista för att välja företag för taktvätt i Stockholm. Jämför metod, offert, försäkring, referenser och takets förutsättningar.",
    excerpt: "Så jämför du företag för taktvätt på ett tryggt och sakligt sätt — utan att bara titta på lägsta pris.",
    date: "2026-10-02",
    readMins: 5,
    heroImage: "/taktvatt.webp",
    sections: [
      { h2: "Be om en bedömning före pris", body: ["Ett seriöst erbjudande börjar med att företaget förstår takets förutsättningar. Material, lutning, åtkomst och mängden påväxt påverkar både metod och kostnad. Ett pris utan någon form av genomgång är svårt att jämföra rättvist."] },
      { h2: "Jämför metod och omfattning", body: ["Be varje leverantör förklara hur arbetet ska utföras och vad som ingår. Det gör det enklare att se skillnaden mellan två offerter som annars kan ha liknande totalsumma."], list: ["Vilken rengöringsmetod används för just takets material?", "Hur skyddas närliggande ytor, växter och avvattning?", "Ingår städning, dokumentation och eventuella tillägg i offerten?", "Vilka villkor gäller för ROT-avdrag, garanti och avbokning?" ] },
      { h2: "Kontrollera verifierbara uppgifter", body: ["Titta efter riktiga omdömen på en oberoende plattform, tydliga kontaktuppgifter och försäkringsinformation som företaget kan styrka. Be gärna om relevanta referenser eller projektbilder där kundens godkännande finns dokumenterat."], list: ["Oberoende omdömen med källa och datum.", "Tydliga skriftliga villkor och kontaktuppgifter.", "Relevant ansvarsförsäkring och säker arbetsmetod.", "Realistiska råd om när taktvätt inte är rätt åtgärd."] },
      { h2: "Välj den som ger tydligast underlag", body: ["Det bästa valet är inte alltid lägsta priset, utan det företag som kan förklara metod, omfattning och nästa steg på ett sätt som passar din fastighet. HPR erbjuder en kostnadsfri TakKoll innan vi lämnar ett tydligt prisförslag."] },
    ],
  },
];

export const getPost = (slug) => posts.find((p) => p.slug === slug);
